import ReactFlow, { Handle } from 'reactflow';
import './builder.css';



export function DraggableKnob() {
  return (
    <div className="drag-handle drag-handle__custom">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="#fff">
        <circle cx="5" cy="12" r="2" />
        <circle cx="12" cy="12" r="2" />
        <circle cx="19" cy="12" r="2" />
      </svg>
    </div>
  );
}

export function ConfigureNodeButton({ instanceID, parentId, onConfigure, type }) {

   // <--- Event + instanceID + optional parentId type = group / task

  return (
    <div
      className="node-button configure-node-button"
      onClick={(e) => {
        e.stopPropagation();
        onConfigure(instanceID, parentId, type, {
          x: e.clientX,
          y: e.clientY
        });
      }}
      title="Edit Node"
    >
      ✏️
    </div>
  );
}

export function DeleteButton({ instanceID, parentId, onDelete }) {
  return (
    <div
      className="node-button delete-node-button"
      onClick={(e) => {
        e.stopPropagation();
        onDelete(instanceID, parentId);
      }}
      title="Delete Node"
    >
      🗑
    </div>
  );
}

export function CutButton({ instanceID, parentId ,onCut }) {
  return (
      <div className='node-button cut-node-button'
        onClick={(e) => {
          onCut(instanceID, parentId);
        }}
      >
        🔪
      </div>
  );
}


export function EditGroupButton({ instanceID, isCurrentInEditMode ,onEditGroup }) {
  return (
      <div
        className="node-button edit-group-button"
        onClick={(e) => {
          e.stopPropagation();
          onEditGroup(instanceID);
        }}
      >
        {isCurrentInEditMode ? '✅' : '⚙️'}
      </div>
  );
}





export const TaskNode = (props) => {
  const { instance_id, label, onEditNode, onDeleteNode, isDraggable, onCut,duration_days } = props.data || {};

  //console.log("[DEBUG] onEditNode: ", onEditNode)
  return (
    <div className="node-container task-node"   style={{
      width: window.WORKFLOWBUILDER_CHILD_WIDTH+"px",
      height: window.WORKFLOWBUILDER_CHILD_HEIGHT+"px"
    }}>
      <Handle type="target" className='targetHandle' position="left" />

      <div className="task-header">
        <span className="task-label">{label || 'TaskNode'}</span>
        <div className="button-container">
            {onCut && <CutButton instanceID={instance_id} parentId={props.data.parentId} onCut={onCut}></CutButton>}
            {onEditNode && (
              <ConfigureNodeButton
                instanceID={instance_id}
                parentId={props.data?.parentId || null}
                onConfigure={onEditNode}
                type={"task"}
              />
            )}
            {onDeleteNode && <DeleteButton instanceID={instance_id} parentId={props.data.parentId} onDelete={onDeleteNode} />}
        </div>
      </div>

      <div className="task-content">
        <p>Vorlage im Tool: {props.data.clickup_vorlage_id}</p>
        <p>Rolle: {props.data.rolle}</p>
        <p>Dauer Tage: {duration_days}</p>
      </div>

      {isDraggable && <DraggableKnob />}

      <Handle type="source" className='sourceHandle' position="right" />
    </div>
  );
};




export const GroupNode = ({ data }) => {
  const {
    instance_id,
    label = 'GroupNode',
    onEditGroup,
    onDeleteNode,
    onEditNode,
    isCurrentInEditMode,
    boundingHeight,
    boundingWidth,
    isDraggable,
  } = data || {};

  return (
    <div
      className="group-node"
      style={{
        width: `${boundingWidth}px`,
        height: `${boundingHeight}px`,
        backgroundColor: isCurrentInEditMode
          ? 'rgba(209, 231, 255, 0.4)'
          : 'rgba(238, 246, 255, 0.2)',
      }}
    >
      <Handle type="target" className='targetHandle' position="left" />

      {/* HEADER mit Buttons */}
      <div className="group-header">
        <span className="group-label">{label}</span>
        <div className="button-container">
          {onEditGroup && <EditGroupButton instanceID={instance_id} isCurrentInEditMode={isCurrentInEditMode} onEditGroup={onEditGroup}></EditGroupButton>}
          {onEditNode && (
            <ConfigureNodeButton
              instanceID={instance_id}
              parentId={null}  // Falls Gruppe keinen Parent hat
              onConfigure={onEditNode}
              type={"group"}
            />
          )}
          {onDeleteNode && <DeleteButton instanceID={instance_id} onDelete={onDeleteNode} />}
        </div>
      </div>

      {/* CONTENT */}
      <div className="group-content">
        {/* Hier könnte später Inhalt rein */}
      </div>

      {/* DRAGGABLE BUTTON */}
      {isDraggable && <DraggableKnob />}

      <Handle type="source" className='sourceHandle' position="right" />
    </div>
  );
};